import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useChatState } from "./useChatState.js";
import { getModalityFromHostname } from "../services/Utils.js";

export function useDynamicTitle() {
  const { t, i18n } = useTranslation("common");
  const location = useLocation();
  const { isChatActive } = useChatState();
  const modality = getModalityFromHostname(window?.location?.hostname);

  useEffect(() => {
    if (import.meta.env.VITE_FEATURE_DYNAMIC_TITLES !== "true") return;
    const titleRules = [
      {
        match: () => location.pathname === "/" && !isChatActive,
        key: "siteTitle.preConversation",
      },
      {
        match: () =>
          modality === "sms" && /^\/[^/]+\/?$/.test(location.pathname),
        key: "siteTitle.preConversation",
      },
      {
        match: () => /^\/feedback\/[^/]+\/?$/.test(location.pathname),
        key: "siteTitle.feedback",
      },
    ];
    const rule = titleRules.find(({ match }) => match());
    document.title = t(rule?.key ?? "siteTitle.default");
  }, [location.pathname, i18n.language, t, isChatActive, modality]);
}
